import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "education-series-detail" */ './index')
);
